import React from 'react';
import PropTypes from 'prop-types';
import AccountIcon from 'mdi-react/AccountIcon';
import * as S from './styles';

const UserAvatar = ({
  avatar,
  displayName,
  email,
  size,
  styling,
  className,
}) => {
  let value;
  if (avatar) {
    return (
      <S.UserAvatar
        className={className}
        styling={styling}
        style={{
          width: size,
          height: size,
          backgroundImage: `url(${avatar})`,
        }}
      />
    );
  }
  if (displayName || email) {
    value = displayName ? displayName.charAt(0) : email.charAt(0);
  } else {
    const svgSize = Math.round(0.75 * size);
    value = <AccountIcon size={svgSize} width={svgSize} height={svgSize} />;
  }

  return (
    <S.UserAvatar
      className={className}
      styling={styling}
      style={{
        width: size,
        height: size,
        lineHeight: `${size}px`,
        fontSize: `${Math.round(0.67 * size)}px`,
      }}
      data-test="UserAvatar"
    >
      {value}
    </S.UserAvatar>
  );
};

UserAvatar.propTypes = {
  avatar: PropTypes.string,
  displayName: PropTypes.string,
  email: PropTypes.string,
  size: PropTypes.number,
  styling: PropTypes.oneOf(['light', 'dark', 'blue']),
  className: PropTypes.string,
};

UserAvatar.defaultProps = {
  avatar: '',
  displayName: '',
  email: '',
  size: 30,
  styling: 'light',
  className: undefined,
};

export default UserAvatar;
